<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :selection="false"
      :toolbar="toolbar"
      labelWidth="120px"
    ></STable>
  </div>
</template>

<script>
import fieldFilter from "@/utils/fieldFilter.js";
export default {
  name: "notifiGroupManagement",
  components: {},
  data() {
    return {
      url: "/battery/dcNoticeGroup/page",
      columns: [
        {
          label: "通知组名称",
          prop: "name",
        },
        {
          label: "号码个数",
          prop: "mobileCount",
        },
        {
          label: "关联项目个数",
          prop: "deviceCount",
        },
        {
          label: "创建人",
          prop: "creatorName",
        },
        {
          label: "创建时间",
          prop: "createTime",
        }
      ],
      // 操作栏
      handles: {
        width: 300,
        btns: [
          {
            label: "详情",
            style: "color:#00CC00",
            permission: "warning.inform.pagedetail",
            handle: (resp) => {
              this.$router.push({
                path: "./notifiGroupDetail",
                query: { data: resp },
              });
            },
          },
          {
            label: "修改",
            style: "color:#00CC00",
            permission: "warning.inform.pageupdate",
            handle: (resp) => {
              this.$router.push({
                path: "./modifyNotifiGroup",
                query: { data: resp },
              });
            },
          },
          {
            label:"删除",
            style:"color:red",
            permission:"warning.inform.delete",
            url:"/battery/dcNoticeGroup/delete",
            method:"delete",
            isConfirm: true,
            confirmText:" 删除后关联的电站告警通知无法下发，确认删除？",
            before:(index,record) => {
              return {
                  id:record.id
              };
            },
            handle: () =>{
                this.$refs.tableref.queryTable();
            }
          }
        ],
      },
      query: [
        {
          label: "通知组名称",
          prop: "name",
          placeholder: "请输入通知组名称",
        }
      ],
      toolbar: [
        {
          label: "新增",
          type: "success",
          permission:"warning.inform.pageadd",
          handle: resp => {
            this.$router.push("./addNotifiGroup")
          }
        }
      ],
    };
  },
  computed: {},
  methods: {
  },
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/BMS/alarmManagement/notifiGroupManagement/notifiGroupManagement.vue